<div [ngClass]="{'closed': !isOpen}">
  <div class="modal-overlay" (click)="close(modalId)"></div>
  <div class="modal">
    <div class="body">
      <ng-content></ng-content>
    </div>
  </div>
</div>